import axios from 'axios';

import ENVIRONMENT from '@/environments/environment';

export const requestVersionControl = async () => new Promise((resolve, reject) => {
  axios.get(`${ENVIRONMENT.BASE_URL_VERSION_CONTROL}${ENVIRONMENT.URL_VERSION_CONTROL}`)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error);
    });
});
